import React from 'react';
import PropTypes from 'prop-types';

import ToggleOff from "./toggle-off";
import ToggleOn from "./toggle-on";

export default class FormToggle extends React.Component<any,any> {

    static propTypes = {
        // Form related fields
        form: PropTypes.object,
        name: PropTypes.string,

        // stand alone without form fields
        onChange: PropTypes.func,
        value: PropTypes.bool,

        // common
        disabled: PropTypes.bool,

        // look and feel
        size: PropTypes.oneOf(['24','20','16','18', '14']).isRequired,
        bgColorClass: PropTypes.string                          // if set will add class with color to active state to match the skin
    };

    public onClickThrottle : any

    constructor(props:any) {
        super(props);

        this.state = {
            value: this.props.form ? this.props.form.getValue(this.props.name) : !!this.props.value,
        };

        this.onClickThrottle = _.throttle(this.onClick, 500);
    }

    componentDidMount() {
        if (this.props.form) this.props.form.registerFormComponent(this.props.name, this);
    }

    UNSAFE_componentWillReceiveProps(nextProps:any) {
        if (!this.props.form && this.state.value !== !!nextProps.value) {
            this.setState({
                value: !!nextProps.value
            });
        }
    }

    onClick = (e?:React.SyntheticEvent) => {
        if (this.props.disabled) return

        if (e) e.stopPropagation()

        const newValue = !this.state.value;

        this.setState({
            value: newValue
        },()=>{
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name,newValue);
            if (this.props.onChange) this.props.onChange(newValue);
        })
    }

    render() {
        const classes = Classes("gd-toggle", "size-"+this.props.size, this.props.className, {
            "checked": this.state.value,
            "disabled": this.props.disabled
        });

        const trackClasses = Classes('toggle-track', {
            [this.props.bgColorClass]: (this.state.value && this.props.bgColorClass)
        });

        return (
            <div className={classes} onClick={this.onClickThrottle}>
                <div className={trackClasses}>
                    {this.state.value && <ToggleOn/>}
                    {!this.state.value && <ToggleOff />}
                </div>
                <div className="toggle-thumb"/>
            </div>
        );
    }
}
